// Constants: 7 MPG diesel, $5.50/gallon average
export const FUEL_MPG = 7;
export const FUEL_PRICE_PER_GAL = 5.50;

export const calcProfit = (load: any, driver?: any) => {
  const revenue = Number(load?.rate_total ?? load?.rate ?? 0);
  const loaded_miles = Number(load?.loaded_miles ?? 0);
  const deadhead_miles = Number(load?.deadhead_miles ?? 0);
  const total_miles = loaded_miles + deadhead_miles;

  // Fuel: total miles ÷ 7 MPG × $5.50/gal
  const fuel_estimated_cost = total_miles > 0 ? (total_miles / FUEL_MPG) * FUEL_PRICE_PER_GAL : 0;

  // Driver pay: use assigned driver's pay settings
  // pay_type: PERCENT = % of gross rate, PER_MILE = $ per loaded mile, FLAT = flat amount
  const resolvedDriver = driver ?? null;
  const payType = resolvedDriver?.pay_type ?? load?.pay_type ?? 'PERCENT';
  const payPercent = Number(resolvedDriver?.pay_rate_percent ?? resolvedDriver?.pay_percent ?? load?.pay_rate_percent ?? 0);
  const payPerMile = Number(resolvedDriver?.pay_rate_per_mile ?? load?.pay_rate_per_mile ?? 0);
  const payFlat = Number(resolvedDriver?.pay_flat ?? load?.pay_flat ?? 0);

  let driver_pay_estimated = 0;
  if (resolvedDriver || (payPercent > 0 || payPerMile > 0 || payFlat > 0)) {
    if (payType === 'PERCENT' && payPercent > 0 && revenue > 0) {
      driver_pay_estimated = revenue * (payPercent / 100);
    } else if (payType === 'PER_MILE' && payPerMile > 0 && loaded_miles > 0) {
      driver_pay_estimated = loaded_miles * payPerMile;
    } else if (payType === 'FLAT' && payFlat > 0) {
      driver_pay_estimated = payFlat;
    } else if (payPercent > 0 && revenue > 0) {
      // fallback: if percent is set, use it regardless of pay_type label
      driver_pay_estimated = revenue * (payPercent / 100);
    }
  }

  const total_cost = fuel_estimated_cost + driver_pay_estimated;
  const net_profit = revenue - total_cost;
  const profit_margin_percent = revenue > 0 ? (net_profit / revenue) * 100 : 0;
  const rpm = loaded_miles > 0 ? revenue / loaded_miles : 0;
  const band = profit_margin_percent >= 18 ? "GREEN" : profit_margin_percent >= 10 ? "YELLOW" : "RED";
  return { revenue, loaded_miles, deadhead_miles, total_miles, fuel_estimated_cost, driver_pay_estimated, total_cost, net_profit, profit_margin_percent, rpm, band };
};
